import { io } from "socket.io-client";
import { API_URL } from "../config/connect";

export const initializeSocket = () => {
    const token = localStorage.getItem("google_id_token");
    
    if (!token) {
        console.error("No authentication token found");
        return null;
    }

    const socket = io(API_URL, {
        auth: {
            Authorization: `Bearer ${token}`,
        },
        transports: ["websocket", "polling"], // Add polling as fallback
        timeout: 20000,
        forceNew: true, // Force new connection
    });

    socket.on("connect", () => {
        console.log("Socket connected successfully");
        console.log("Socket ID:", socket.id);
    });

    socket.on("disconnect", (reason) => {
        console.log("Socket disconnected:", reason);
        if (reason === "io server disconnect") {
            // Server disconnected, try to reconnect
            socket.connect();
        }
    });

    socket.on("connect_error", (error) => {
        console.error("Socket connection error:", error);
        console.error("Error details:", error.message);
    });

    socket.on("reconnect", (attemptNumber) => {
        console.log("Socket reconnected after", attemptNumber, "attempts");
    });

    socket.on("reconnect_error", (error) => {
        console.error("Socket reconnection error:", error);
    });

    return socket;
};